<!-- 调整名单 -->
<template>
  <div
    class="container"
    :style="{ '--color': themeColor, '--lightColor': lightThemeColor }"
  >
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <header class="header">
        <p class="p1">
          2020-06-20-2020-06-23 3晚 单人间
          <span>（ 该商品最多可供 1人使用）</span> 3间
        </p>
        <div>
          <el-button @click="handlerSaveClick" type="primary">保存</el-button>
          <el-button @click="dialogVisible = false" plain>关闭</el-button>
        </div>
      </header>
      <div class="main">
        <el-table border :data="tableData" style="width: 100%">
          <el-table-column fixed="left" type="selection" width="55">
          </el-table-column>
          <el-table-column
            fixed="left"
            align="center"
            prop="date"
            label="商品序号"
            width="70"
          >
          </el-table-column>
          <el-table-column
            fixed="left"
            width="70"
            align="center"
            prop="name"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            width="60"
            align="center"
            prop="address"
            label="人数"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="中文名字"
            width="70"
          >
          </el-table-column>
          <el-table-column
            width="70"
            align="center"
            prop="address"
            label="英文姓名"
          >
          </el-table-column>
          <el-table-column
            width="60"
            align="center"
            prop="address"
            label="性别"
          >
          </el-table-column>
          <el-table-column
            width="70"
            align="center"
            prop="address"
            label="证件类型"
          >
          </el-table-column>
          <el-table-column
            width="120"
            align="center"
            prop="address"
            label="证件号码"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            prop="address"
            label="联系电话"
          >
          </el-table-column>
          <el-table-column
            width="140"
            align="center"
            prop="address"
            label="最后一次修改时间"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            prop="address"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            width="60"
            align="center"
            prop="address"
            label="类型"
          >
          </el-table-column>
          <el-table-column
            width="80"
            align="center"
            prop="address"
            label="国籍"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            prop="address"
            label="出生日期"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            prop="address"
            label="出生地"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            prop="address"
            label="签发地"
          >
          </el-table-column>
          <el-table-column
            width="120"
            align="center"
            prop="address"
            label="签发日期"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      tableData: [{}],
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["themeColor"]),
    ...mapState(["lightThemeColor"]),
    ...mapState(["nearThemeColor"]),
  },
  watch: {},
  methods: {
    handlerSaveClick() {
      this.$confirm(`确认保存吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          });
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0 !important;
}
/deep/ .el-dialog {
  border-radius: 0 !important;
}
/deep/ .el-dialog__body {
  padding: 0 !important;
  padding-bottom: 0.5rem !important;
}
/deep/ .el-dialog__headerbtn {
  display: none;
}
/deep/ .el-checkbox__inner {
  border-radius: 50% !important;
}
.container {
  .header {
    height: 0.8rem;
    padding: 0 0.2rem 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .p1 {
      color: rgba(216, 27, 67, 1);
      font-size: 0.14rem;
      font-family: SourceHanSansSC-bold;
      font-weight: bold;
      span {
        color: #000;
      }
    }
  }
  .main {
    padding: 0 0.2rem 0 0.4rem;
  }
}
</style>
